const ROOT = '/';
const LOGIN = '/login';
const FACTORIES = '/factories/:id';
const SITES = '/sites/:id';
const DEVICES = '/devices/:id';
const DASHBOARD = '/app/dashboard';
const BRANDS = '/app/brands';
const LIST_DEVICES = '/app/devices';
const LIST_SITES = '/app/sites';
const DIAGRAM = '/app/diagram';
const LIST_MODELS = '/app/models';
const LIST_PROTOCOLS = '/app/protocols';
const LIST_CHANNELS = '/app/channels';
const LIST_ITEMS = '/app/items';
const LIST_ALERTS = '/app/alerts';
const CHARTS = '/app/charts';
const CHARTS_COMPARE = '/app/charts-compare';
const REPORTS = '/app/reports';
const REPORT_DEVICE = '/app/report-devices';
const TRENDS = '/app/trends';
const SETTING_GENERAL = '/setting/general';
const SETTING_INVOICES = '/setting/invoice';
const SETTING_USER = '/setting/user';
const SETTING_PRICES = '/setting/prices';
const SETTING_EMAILS = '/setting/emails';
const SETTING_ALARM = '/setting/alarm';
const LIST_ALERTS_SETTING = '/setting/alerts-setting';
const SETTING_DASHBOARD = '/setting/dashboard';
const REBOOT_SYSTEM = '/setting/reboot-system';
const ARCHITECTURE = '/app/architecture';

export default {
  ROOT,
  LOGIN,
  FACTORIES,
  SITES,
  DEVICES,
  DASHBOARD,
  BRANDS,
  LIST_DEVICES,
  LIST_SITES,
  LIST_MODELS,
  LIST_PROTOCOLS,
  LIST_CHANNELS,
  LIST_ITEMS,
  LIST_ALERTS_SETTING,
  LIST_ALERTS,
  DIAGRAM,
  CHARTS,
  CHARTS_COMPARE,
  REPORTS,
  TRENDS,
  SETTING_GENERAL,
  SETTING_INVOICES,
  SETTING_USER,
  SETTING_PRICES,
  SETTING_EMAILS,
  SETTING_ALARM,
  SETTING_DASHBOARD,
  REPORT_DEVICE,
  REBOOT_SYSTEM,
  ARCHITECTURE,
};
